import React, { Fragment, useEffect, useRef, useState } from 'react';
import {
  TabContainer,
  TabTitle,
  AddButton,
  AddText,
  ContentContainer,
  Content,
  ToDoContainer,
  ToDoName,
  ContractName,
  IconPosition,
  ToDoContainerCompleted,
  ToDoNameCompleted,
  ToDoCompleted,
  ToDoDate,
  StyledInput,
  ToDoContainerDateDelete,
  ToDoHeaderIconsContainer,
  StyledRow,
  NoData,
} from './ClientDetails.styles';
import {
  SmallModalContainer,
  Background,
  ModalTitleSmall,
  ButtonContainerGap,
  StyledButton,
  ButtonText,
} from '../../../components/Modal/ModalComponent.styles.js';
import { ReactComponent as Add } from '../../../assets/icons/btnAdd.svg';
import { ReactComponent as Delete } from '../../../assets/icons/delete.svg';
import { ReactComponent as Document } from '../../../assets/icons//document.svg';
import { ReactComponent as Edit } from '../../../assets/icons//edit.svg';

import { useDispatch, useSelector } from 'react-redux';
import {
  createTemplateToDoForClient,
  createToDoForClient,
  deleteToDoForClient,
  editClientToDo,
  getClientToDos,
  getToDoTemplates,
} from '../../../store/slice/toDo/asyncThunks';
import {
  selectClientToDos,
  selectCreateToDoForClientPending,
  selectCreateToDoTemplateForClientPending,
  selectDeleteToDoForClientPending,
  selectEditClientToDoPending,
  selectGetClientToDosPending,
  selectGetToDoTemplatesPending,
  selectToDoTemplates,
} from '../../../store/slice/toDo/slice';
import { selectClientData } from '../../../store/slice/vendor/slice';
import { Waveform } from '@uiball/loaders';
import { ReactComponent as Calendar } from '../../../assets/icons/date.svg';
import { dateFormatterHalfMonth } from '../../../utils/utils';

import ModalComponent from '../../../components/Modal/ModalComponent';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {
  CheckboxContainer,
  ModalTemplateContainer,
  NoDataContainer,
  TemplateContainer,
  TemplateDescription,
  TemplateTitle,
} from '../ClientsPage.styles';
import { notifyError, notifyErrorLeft } from '../../../utils/notify';
import Checkbox from '../../../components/utils/Checkbox/Checkbox';

const ToDos = ({ id }) => {
  const dispatch = useDispatch();
  const toDos = useSelector(selectClientToDos);
  const getClientToDosPending = useSelector(selectGetClientToDosPending);
  const createToDoForClientPending = useSelector(selectCreateToDoForClientPending);
  const client = useSelector(selectClientData);

  const clientInfo = useSelector(selectClientData);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalTemplateOpen, setIsModalTemplateOpen] = useState(false);

  const [startDate, setStartDate] = useState(new Date());

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');

  const [selectedTemplates, setSelectedTemplates] = useState([]);

  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState('');

  const getToDoTemplatesPending = useSelector(selectGetToDoTemplatesPending);

  const toDoTemplates = useSelector(selectToDoTemplates);
  const createToDoTemplateForClientPending = useSelector(selectCreateToDoTemplateForClientPending);
  const deleteLoading = useSelector(selectDeleteToDoForClientPending);
  const [deletingId, setDeletingId] = useState(null);

  const datePickerRef = useRef(null);

  const [toDoId, setToDoId] = useState('');
  const [areYouSureModal, setAreYouSureModal] = useState(false);
  const [isVisible, setIsVisible] = useState(areYouSureModal);
  const editClientToDoPending = useSelector(selectEditClientToDoPending);

  useEffect(() => {
    let timer;
    if (areYouSureModal) {
      setIsVisible(true);
    } else {
      timer = setTimeout(() => setIsVisible(false), 250);
    }

    return () => clearTimeout(timer);
  }, [areYouSureModal]);

  const handleIconClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  useEffect(() => {
    dispatch(getClientToDos({ id: id, page: 1 }));
  }, [dispatch, id]);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setTitle('');
    setDescription('');
    setStartDate(new Date());
  };

  const closeTemplateModal = () => {
    setSelectedTemplates([]);
    setIsModalTemplateOpen(false);
  };

  const openTemplateModal = () => {
    dispatch(getToDoTemplates({ page: 1 }));
    setIsModalTemplateOpen(true);
  };

  const openEditModal = (toDoTitle, toDoDescription, date, id) => {
    setIsEdit(true);
    setEditId(id);
    setTitle(toDoTitle);
    setDescription(toDoDescription);
    setStartDate(new Date(date));
    setIsModalOpen(true);
  };

  const closeEditModal = () => {
    setIsModalOpen(false);
    setEditId('');
    setIsEdit(false);
    setTitle('');
    setDescription('');
    setStartDate(new Date());
  };

  const handleCreateToDo = () => {
    const sendData = {
      id: id,
      body: {
        title,
        ...(description && { description }),
        date: startDate.getTime(),
      },
    };
    dispatch(createToDoForClient(sendData))
      .unwrap()
      .then(() => {
        setTitle('');
        setDescription('');
        setStartDate(new Date());
        setIsModalOpen(false);
      })
      .catch(err => {
        console.log(err);
        notifyErrorLeft(err.message);
      });
  };

  const handleDelete = id => {
    setDeletingId(id);
    dispatch(deleteToDoForClient(id))
      .unwrap()
      .then(() => {
        setDeletingId(null);
      })
      .catch(err => {
        console.log(err);
        notifyError(err.message);
      });
  };

  const handleSelect = id => {
    const existingTemplate = selectedTemplates.find(template => template === id);
    if (existingTemplate) {
      setSelectedTemplates(prev => {
        return prev.filter(template => template !== id);
      });
    } else {
      setSelectedTemplates(prev => [...prev, id]);
    }
  };

  const handleCreateTemplateToDoForClient = () => {
    dispatch(createTemplateToDoForClient({ id: client.id, templates: selectedTemplates }))
      .unwrap()
      .then(() => {
        setSelectedTemplates([]);
        setIsModalTemplateOpen(false);
      })
      .catch(err => {
        console.log(err);
        notifyErrorLeft(err.message);
      });
  };

  const handleEditToDo = () => {
    dispatch(
      editClientToDo({ id: editId, body: { title, ...(description && { description }), date: startDate.getTime() } }),
    )
      .unwrap()
      .then(() => {
        closeEditModal();
      })
      .catch(err => {
        console.log(err);
        notifyErrorLeft(err.message);
      });
  };

  return (
    <ContentContainer>
      <TabContainer>
        <TabTitle>To Do's</TabTitle>
        <ToDoHeaderIconsContainer>
          <AddButton onClick={openTemplateModal}>
            <Document />
            <AddText>UseTemplate</AddText>
          </AddButton>
          <AddButton onClick={openModal}>
            <Add />
            <AddText>New To Do</AddText>
          </AddButton>
        </ToDoHeaderIconsContainer>
      </TabContainer>

      {!getClientToDosPending ? (
        <>
          <Content className="vertical-scroll">
            {toDos.data.length ? (
              <>
                {toDos.data.map(item => (
                  <Fragment key={item.id}>
                    {item.status ? (
                      <ToDoContainerCompleted>
                        <ToDoNameCompleted>{item.title}</ToDoNameCompleted>
                        <ToDoCompleted>{'Completed'}</ToDoCompleted>
                      </ToDoContainerCompleted>
                    ) : (
                      <ToDoContainer>
                        <ToDoName>{item.title}</ToDoName>
                        <ToDoContainerDateDelete>
                          <ToDoDate>{`Complete by:  ${dateFormatterHalfMonth(item.date)}`}</ToDoDate>
                          <StyledRow>
                            {deleteLoading && item.id === deletingId ? (
                              <Waveform size={20} lineWeight={3} speed={1} color="black" />
                            ) : (
                              <>
                                <Delete
                                  className="icon-edit"
                                  onClick={() => {
                                    setAreYouSureModal(true);
                                    setToDoId(item.id);
                                  }}
                                />
                                <Edit
                                  className="icon-edit"
                                  onClick={() => {
                                    openEditModal(item.title, item.description, item.date, item.id);
                                  }}
                                />
                              </>
                            )}
                          </StyledRow>
                        </ToDoContainerDateDelete>
                      </ToDoContainer>
                    )}
                  </Fragment>
                ))}
              </>
            ) : (
              <NoDataContainer>
                <ContractName>You don't have to do's with {clientInfo.firstName}.</ContractName>
              </NoDataContainer>
            )}
          </Content>
        </>
      ) : (
        <NoDataContainer>
          <Waveform size={40} lineWeight={3.5} speed={1} color="black" />
        </NoDataContainer>
      )}
      <ModalComponent
        isOpen={isModalOpen}
        onClose={() => (isEdit ? closeEditModal() : closeModal())}
        title={isEdit ? 'Edit To Do' : 'New To Do'}
        onCreate={() => (isEdit ? handleEditToDo() : handleCreateToDo())}
        rightButtonTitle={isEdit && 'Save'}
        createDisabled={!title || !description}
        loading={createToDoForClientPending || editClientToDoPending}>
        <StyledInput placeholder="Task Note" onChange={n => setTitle(n.target.value)} value={title} />
        <StyledInput placeholder="Details" onChange={n => setDescription(n.target.value)} value={description} />
        <div className="border-bottom">
          <DatePicker
            placeholderText="Complete by (date)"
            className="date-picker"
            selected={startDate}
            calendarClassName="scale"
            dateFormat="MMMM d, yyyy"
            onChange={date => setStartDate(date)}
            minDate={new Date()}
            ref={datePickerRef}
          />
          <IconPosition onClick={handleIconClick}>
            <Calendar />
          </IconPosition>
        </div>
      </ModalComponent>

      <ModalComponent
        isOpen={isModalTemplateOpen}
        onClose={closeTemplateModal}
        title={'Use Template'}
        onCreate={handleCreateTemplateToDoForClient}
        createDisabled={!selectedTemplates.length}
        rightButtonTitle={'Select'}
        loading={createToDoTemplateForClientPending}>
        {!getToDoTemplatesPending ? (
          <>
            {toDoTemplates.data.length ? (
              <>
                {toDoTemplates.data.map(item => {
                  const isSelected = selectedTemplates.find(template => template === item.id);
                  return (
                    <ModalTemplateContainer key={item.id}>
                      <TemplateContainer>
                        <TemplateTitle>{item.title}</TemplateTitle>
                        <TemplateDescription>
                          {item.description.length > 30 ? item.description.slice(0, 30) + '...' : item.description}
                        </TemplateDescription>
                      </TemplateContainer>
                      <CheckboxContainer
                        onClick={() => {
                          handleSelect(item.id);
                        }}>
                        <Checkbox checked={!isSelected} width={24} height={24} stroke={'#BC826C'} />
                      </CheckboxContainer>
                    </ModalTemplateContainer>
                  );
                })}
              </>
            ) : (
              <NoDataContainer>
                <NoData>
                  Have the same or similar to-dos for your clients? Set these up under the “templates” tab on your main
                  menu
                </NoData>
              </NoDataContainer>
            )}
          </>
        ) : (
          <NoDataContainer>
            <Waveform size={40} lineWeight={3.5} speed={1} color="black" />
          </NoDataContainer>
        )}
      </ModalComponent>
      {isVisible && (
        <>
          <Background $open={areYouSureModal} $bg />
          <SmallModalContainer $open={areYouSureModal}>
            <ModalTitleSmall style={{ textAlign: 'center' }}>
              Are you sure you want to delete this to do?
            </ModalTitleSmall>
            <ButtonContainerGap style={{ gap: 20 }}>
              <StyledButton onClick={() => setAreYouSureModal(false)}>
                <ButtonText>Cancel</ButtonText>
              </StyledButton>

              <StyledButton
                onClick={() => {
                  if (!deleteLoading) {
                    handleDelete(toDoId);
                    setToDoId('');
                    setAreYouSureModal(false);
                  }
                }}
                $disabled={deleteLoading}
                $black>
                {!deleteLoading ? (
                  <ButtonText $black>Yes</ButtonText>
                ) : (
                  <Waveform size={26} lineWeight={3.5} speed={1} color="white" />
                )}
              </StyledButton>
            </ButtonContainerGap>
          </SmallModalContainer>
        </>
      )}
    </ContentContainer>
  );
};

export default ToDos;
